export default "__VITE_ASSET__BcAy0HS7__"